module.exports = __webpack_public_path__ + "static/media/xls.d5017a71.svg";